import axios from 'axios';
import Vue from 'vue';
import App from './App.vue';
import { createStore } from './store';
import { createRouter } from './router';
import VueI18n from 'vue-i18n';
import messages from './i18n';

Vue.mixin({
  methods: {
    getLocalePath() {
      const locale = this.$store.state.currentLocale;
      return locale.locale === 'ru' ? '' : `/${locale.locale}`;
    },

    siteUrl(urlPart) {
      const locale = this.$store.state.currentLocale;
      return `${locale.href}${urlPart}`;
    },

    eventUrl() {
      return this.getLocalePath() + '/event/';
    },

    ratingUrl() {
      return this.getLocalePath() + '/rating/';
    },

    shopUrl(slug) {
      const locale = this.$store.state.currentLocale;
      if (this.$store.state.subdomainsEnabled) {
        return this.$store.state.host.replace(`//${this.$store.state.subdomain}.`, `//${slug}.`);
      }
      return locale.locale === 'ru' ? `/shop/${slug}/` : `/${locale.locale}/${slug}/`;
    },

    showCoupon(coupon) {
      axios.post(this.eventUrl(), { store: coupon.slug, coupon_id: coupon.coupon_id, event: 'clicked' });
      window.yaCounter44729944 && window.yaCounter44729944.reachGoal('viewpromo');
      const shopUrl = `${location.origin}${location.pathname}`;
      let query;
      if (/coupon=[0-9]*/.test(location.search)) {
        query = location.search.replace(/coupon=[0-9]*/, `coupon=${coupon.coupon_id}`);
      } else {
        query = `${location.search}${location.search.indexOf('?') !== -1 ? '&' : '?'}coupon=${coupon.coupon_id}`;
      }
      window.open(`${shopUrl}${query}`, '_blank');
      location.href = coupon.affiliated_link;
    },

    subscribeUrl() {
      return this.getLocalePath() + '/subscribe/';
    },
  }
});

Vue.use(VueI18n);

export function createApp(beforeAppInit) {
  const store = createStore();
  const router = createRouter();
  const i18n = new VueI18n({
    messages,
    silentTranslationWarn: true,
    fallbackLocale: 'ru',
  });

  beforeAppInit && beforeAppInit({ store, router, i18n });

  const app = new Vue({
    store,
    router,
    i18n,
    render: (h) => h(App)
  });

  return { app, router, store };
};